import { THEME_COLOR } from "../../../../styles/colors";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Divider from "@amzn/meridian/esm/components/divider";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";

const BEFORE_BG = THEME_COLOR.BLUSH;
const BEFORE_DIVIDER = THEME_COLOR.ROSE;
const AFTER_BG = THEME_COLOR.MINT_GREEN;
const AFTER_DIVIDER = THEME_COLOR.LIGHT_TEAL;
const CODE_BG = THEME_COLOR.MIST_GRAY;
const BORDER_RADIUS = 12;

const CodeDiffCard = ({ title, before, after }) => {
  return (
    <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.MIST_GRAY, boxBorderRadiusOutline: BORDER_RADIUS }}>
      <Box type="outline" spacingInset="400">
        <Column spacing="300">
          {title && <Text type="h100">{title}</Text>}
          {before != null && (
              <Theme tokens={{ boxBorderRadiusOutline: BORDER_RADIUS, boxBorderWidth: 0, dividerColor: BEFORE_DIVIDER }}>
                <Box type="outline" backgroundColor={BEFORE_BG}>
                  <Row spacingInset="200 300">
                    <Text type="b100" color="error">Before</Text>
                  </Row>
                  <Divider />
                  <Row spacingInset="300" backgroundColor={CODE_BG}>
                    <Text type="b200">{before}</Text>
                  </Row>
                </Box>
              </Theme>
            )}
            {after != null && (
              <Theme tokens={{ boxBorderRadiusOutline: BORDER_RADIUS, boxBorderWidth: 0, dividerColor: AFTER_DIVIDER }}>
                <Box type="outline" backgroundColor={AFTER_BG}>
                  <Row spacingInset="200 300">
                    <Text type="b100" color="success">After</Text>
                  </Row>
                  <Divider />
                  <Row spacingInset="300" backgroundColor={CODE_BG}>
                    <Text type="b200">{after}</Text>
                  </Row>
                </Box>
              </Theme>
            )}
        </Column>
      </Box>
    </Theme>
  );
};

export default CodeDiffCard;
